import React, { useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { AddressCard } from '../location/address-card';
import { PaymentDetails } from '../payment/payment-details';

function SessionDetailModalBody({
  address,
  orders,
  config,
  spot,
  menuInfo,
  feature,
}) {
  const classes = useStyles();

  const payment = useMemo(
    () => ({
      orders,
    }),
    [orders]
  );

  return (
    <div className={classes.container}>
      <AddressCard
        address={address}
        config={config}
        noStreetNumber={address.is_no_number}
        complement={address.complement}
      />
      {/* <div>– Mostrar local de entrega (editar)</div>
      <div>– Mostrar previsão de entrega</div>
      <div>– Mostrar taxa de entrega</div>
      <br />
      <div>– Mostrar contato (editar)</div>
      <div>– Mostrar pedido</div> */}
      <div>x </div>
      <div>y </div>
      <PaymentDetails
        payment={payment}
        spot={spot}
        menuInfo={menuInfo}
        feature={feature}
      />
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // display: 'flex',
    // alignItems: 'flex-start',
    // textAlign: 'left',
    // border: '1px solid red',
  },
});

export { SessionDetailModalBody };
